import { render } from "./B2bIntegrations.vue?vue&type=template&id=7b4ec722&scoped=true&ts=true"
import script from "./B2bIntegrations.vue?vue&type=script&lang=ts"
export * from "./B2bIntegrations.vue?vue&type=script&lang=ts"

import "./B2bIntegrations.vue?vue&type=style&index=0&id=7b4ec722&lang=scss&scoped=true"

import exportComponent from "C:\\BuildAgent\\work\\bd59560cf4570ff\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b4ec722"]])

export default __exports__